/* eslint-disable @typescript-eslint/no-unused-vars */
import * as X from "@/ui";

import CheckImage from "@/assets/shared-advantage-check.svg";

import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";

import { ShippingTargetCard } from "@/providers/strapi/content/types/components/shipping.component";

import ReactMarkdown from "react-markdown";
import { StrapiImage } from "@/providers/strapi";



type ViewModel = {
  title: string
  cta: string,
  professionals: {
    // image: StaticImageData,
    image: StrapiImage
    title: string
    bullets: Array<string>
  },
  individuals: {
    image: StrapiImage,
    title: string,
    bullets: Array<string>
  }
}



// const defaultData = {
//   title: {
//     en: <>Who is <strong>Zapptax Shipping</strong> for?</>,
//     fr: <>À qui s’adresse <strong>Zapptax Shipping</strong>{X.Nbsp}?</>,
//     ko: 'Zapptax Shipping은 누구를 위한 서비스인가요?',
//   },

//   cta: {
//     en: 'Contact us',
//     fr: 'Contactez-nous',
//     ko: '문의하기',
//   },

//   professionals: {
//     image: ImageProfessionals,
//     title: {
//       en: <>Businesses and professionals</>,
//       fr: <>Entreprises et professionnls</>,
//       ko: <>기업 및 전문가</>,
//     },
//     bullets: [
//       {
//         en: <>The ideal solution for traders, resellers, and professional buyers managing recurring or bulk orders</>,
//         fr: <>Solution idéale pour traders, revendeurs et acheteurs professionnels gérant des commandes récurrentes ou en gros</>,
//         ko: <>빈번한 주문과 대량 구매가 필요한 리셀러 및 B2B 고객을 위한 최적의 솔루션입니다.</>,
//       },
//       {
//         en: <>An optimized VAT refund process tailored to large transactions</>,
//         fr: <>Processus de remboursement de TVA optimisé pour les transactions importantes</>,
//         ko: <>대규모 비즈니스 거래를 위한 효율적인 VAT 환급 프로세스를 제공합니다.</>,
//       },
//     ],
//   },

//   individuals: {
//     image: ImageIndividuals,
//     title: {
//       en: <>Individual consumers</>,
//       fr: <>Consommateurs particuliers</>,
//       ko: <>개인 소비자</>,
//     },
//     bullets: [
//       {
//         en: <>A service open to all, ideal for high-value or large-volume purchases</>,
//         fr: <>Service accessible à tous, idéal pour les achats de grande valeur ou en gros volume</>,
//         ko: <>고가 제품 구매 또는 대량 주문을 필요로 하는 고객님께 최적화된 옵션을 제공합니다.</>,
//       },
//       {
//         en: <>Available for purchases made in France, Belgium, Spain, Luxembourg, and the United Kingdom</>,
//         fr: <>Disponible pour les achats réalisés en France, Belgique, Espagne, Luxembourg et Royaume-Uni</>,
//         ko: <>이 혜택은 프랑스, 벨기에, 스페인, 룩셈부르크, 영국에서 구매한 상품에만 해당합니다.</>,
//       },
//     ],
//   },
// };
const buildViewModel = (content: ShippingTargetCard): ViewModel => ({
  title: content.title,
  cta: content.cta,
  professionals: {
    title: content.proTitle,
    image: content.proPicture,
    // image: ImageProfessionals,
    bullets: content.proItems.map((items) => items.content)
  },
  individuals: {
    title: content.customerTitle,
    image: content.customerPicture,
    bullets: content.customerItems.map((items) => items.content)
  }
})

export function WhoIsItForSection(props: X.PageProps) {
  return (
    <section id="who" className={X.clsx("scroll-mt-[120px] xl:my-20")}>
      <Mobile {...props} />
      <Desktop {...props} />
    </section>
  );
}


function Mobile(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const targetCard = useShippingPage('shippingTargetCard');
  const data = buildViewModel(targetCard);
  return (
    <div className={X.clsx(X.mobileOnly(), "bg-surface-purple")}>
      <div className="bg-white ml-mobile-margin-half pl-mobile-margin-half pr-mobile-margin rounded-tl-4xl pt-8">
        {/* <h2 className={X.clsx("text-[34px] [&_strong]:font-medium leading-tight")}>{tr(data.title)}</h2> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <h2 {...props} className={X.clsx("text-[34px] [&_strong]:font-medium leading-tight")} />
        }}>
          {/* {tr(data.title)} */}
          {data.title}
        </ReactMarkdown>
        <div className={X.clsx(
          "bg-white py-10 rounded-tr-4xl flex flex-col gap-6",
        )}>

          {[data.professionals, data.individuals].map((audience, i) => (
            <div key={i}>
              <div className="flex flex-row items-end gap-4 mb-6">
                {/* <h3 className="text-[20px] max-w-[215px] font-semibold leading-tight">
                  {tr(audience.title)}

                </h3> */}
                <ReactMarkdown
                  components={{
                    p: ({ ...props }) => <h3 {...props} className="text-[20px] max-w-[215px] font-semibold leading-tight" />,
                    h1: ({ ...props }) => <h3 {...props} className="text-[20px] max-w-[215px] font-semibold leading-tight" />,
                    h2: ({ ...props }) => <h3 {...props} className="text-[20px] max-w-[215px] font-semibold leading-tight" />,
                    h3: ({ ...props }) => <h3 {...props} className="text-[20px] max-w-[215px] font-semibold leading-tight" />,
                    h4: ({ ...props }) => <h3 {...props} className="text-[20px] max-w-[215px] font-semibold leading-tight" />,
                    h5: ({ ...props }) => <h3 {...props} className="text-[20px] max-w-[215px] font-semibold leading-tight" />,
                  }}>
                  {audience.title}
                </ReactMarkdown>

                <X.Image
                  alt="Support"
                  className="h-auto w-[40%] rounded-2xl"
                  // src={audience.image}
                  src={audience.image.url}
                  width={audience.image.width}
                  height={audience.image.height}
                  unoptimized
                />
              </div>

              <ul className="flex flex-col gap-6 mb-6">
                {audience.bullets.map((text, i) => (
                  <li key={i} className="flex flex-row items-start gap-2 text-[14px] font-medium">
                    <X.Image
                      src={CheckImage}

                      alt="Check" className="w-[34px] h-[34px]" />
                    <div className="flex-1">
                      <ReactMarkdown>
                        {text}
                      </ReactMarkdown>
                      {/* {tr(text)} */}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="flex flex-col items-start">
            <X.Button
              primary
              className="X-Open-Intercom"
              // label={tr(data.cta)}
              label={data.cta}
            />
          </div>
        </div>
      </div>
    </div >
  );
}


function Desktop(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const { ref, inView } = X.useInViewObserver<HTMLDivElement>();

  const targetCard = useShippingPage('shippingTargetCard');
  const data = buildViewModel(targetCard)

  return (
    <div className={X.clsx(X.desktopOnly("block"), "mb-40")}>
      {/* <h2 className={X.clsx(
        "max-w-content mx-auto",
        "text-[48px] [&_strong]:font-medium text-center mb-10",
      )}>{tr(data.title)}</h2> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className={X.clsx(
          "max-w-content mx-auto",
          "text-[48px] [&_strong]:font-medium text-center mb-10",
        )} />
      }}>
        {/* {tr(data.title)} */}
        {data.title}
      </ReactMarkdown>

      <div ref={ref} className={X.clsx("max-w-content mx-auto relative h-[540px]")}>
        <div className={X.clsx(
          "bg-surface-green p-10 rounded-t-4xl rounded-bl-4xl absolute left-0 top-0 right-[48%] pr-20 pb-[140px] pt-20 min-h-[660px]",
          "transition-transform duration-500 transform-gpu",
          inView ? "translate-x-0" : "-translate-x-[100vw]",
        )}>
          {/* <h3 className="max-w-full text-[26px] mb-8 font-semibold leading-tight">
            {tr(data.professionals.title)}
            {data.professionals.title}
          </h3> */}
          <ReactMarkdown
            components={{
              p: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h1: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h2: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h3: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h4: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h5: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
            }}>
            {data.professionals.title}
          </ReactMarkdown>


          <ul className="flex flex-col gap-6 mb-6">
            {data.professionals.bullets.map((text, i) => (
              <li key={i} className="flex flex-row items-start gap-4 text-[18px] font-semibold">
                <X.Image src={CheckImage} alt="Check" className="w-[40px] h-[40px]" />
                <div className="flex-1">
                  {/* {tr(text)} */}
                  <ReactMarkdown>
                    {text}
                  </ReactMarkdown>
                </div>
              </li>
            ))}
          </ul>

          <X.Image
            alt="Support"
            className="h-auto w-[60%] rounded-2xl"
            // src={data.professionals.image}
            src={data.professionals.image.url}
            width={data.professionals.image.width}
            height={data.professionals.image.height}
            unoptimized
          />
        </div>

        <div className={X.clsx(
          "absolute bg-white p-10 rounded-t-4xl left-[48%] right-0 top-10 pb-40",
          "transition-transform duration-500 transform-gpu",
          inView ? "translate-x-0" : "translate-x-[100vw]",
        )}>
          {/* <h3 className="text-[26px] font-semibold mb-8 leading-tight">
            {tr(data.individuals.title)}
            {data.individuals.title}
          </h3> */}
          <ReactMarkdown
            components={{
              p: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h1: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h2: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h3: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h4: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
              h5: ({ ...props }) => <h3 {...props} className="max-w-full text-[26px] mb-8 font-semibold leading-tight" />,
            }}>
            {data.individuals.title}
          </ReactMarkdown>
          <ul className="flex flex-col mt-8 gap-8">
            {data.individuals.bullets.map((text, i) => (
              <li key={i} className="flex flex-row items-start gap-4 text-[18px] font-semibold">
                <X.Image
                  src={CheckImage}
                  alt="Check" className="w-[40px] h-[40px]" />
                <div className="flex-1">
                  {/* {tr(text)} */}
                  <ReactMarkdown>
                    {text}
                  </ReactMarkdown>
                </div>
              </li>
            ))}
          </ul>

          <div className="flex flex-row mt-8">
            <X.Image
              alt="Support"
              className="h-auto w-[60%] rounded-2xl"
              // src={data.individuals.image}
              src={data.individuals.image.url}
              width={data.individuals.image.width}
              height={data.individuals.image.height}
              unoptimized
            />
          </div>
        </div>

      </div>
      <X.Button
        primary lg
        // label={tr(data.cta)}
        label={data.cta}
        className={X.clsx(
          "X-Open-Intercom",
          "absolute left-1/2 bottom-0 -translate-x-1/2 translate-y-8"
        )}
      />
    </div>
  );
}
